import { Stack } from '@mui/material';

import { selectImpactCalculateTourForCurrentProject } from '@/domain/impact-calculate-tour/impact-calculate-tour.selectors';
import { selectProjectTourOnTourSequenceById } from '@/domain/project-tour-ontour/project-tour-ontour.selectors';
import { ScoreText } from '@/ui/components/score-text/ScoreText';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { TourCard } from '../components/TourCard';

export function SequenceOverview({ sequenceId }: { sequenceId: number }) {
  const sequence = useAppSelector(
    selectProjectTourOnTourSequenceById(sequenceId),
  );

  const calculateTour = useAppSelector(
    selectImpactCalculateTourForCurrentProject,
  );

  if (!sequence) {
    return null;
  }

  const eventCount =
    calculateTour?.stats?.ontour?.bySequence[sequence.id]?.eventCount || 0;

  const co2PerEvent =
    calculateTour?.stats?.ontour?.bySequence[sequence.id]?.co2AveragePerEvent ||
    0;

  const sequenceScoreCo2 =
    calculateTour?.co2?.ontour.bySequence[sequence.id]?.score || 0;

  return (
    <TourCard title={translate('ProjectsTour.OnTour.total')}>
      <Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
        <Stack sx={{ width: '10rem' }}>
          <ScoreText
            value={eventCount?.toString() || '-'}
            text={translate('ProjectsTour.dates')}
          />
        </Stack>
        <Stack sx={{ width: '10rem', flexDirection: 'row' }}>
          <ScoreText
            value={`${sequenceScoreCo2.toString()} ${translate('Projects.teCO2')}`}
            text={translate('ProjectsTour.emited')}
            variant={'box'}
          />
        </Stack>
        <Stack sx={{ width: '10rem', flexDirection: 'row' }}>
          <ScoreText
            value={`${co2PerEvent.toString()} ${translate('Projects.teCO2')}`}
            text={translate('ProjectsTour.emited-by-date')}
            variant={'box'}
          />
        </Stack>
      </Stack>
    </TourCard>
  );
}
